import { render, staticRenderFns } from "./cooperationBranchList.vue?vue&type=template&id=57561894&"
import script from "./cooperationBranchList.vue?vue&type=script&lang=js&"
export * from "./cooperationBranchList.vue?vue&type=script&lang=js&"
import style0 from "./cooperationBranchList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57561894')) {
      api.createRecord('57561894', component.options)
    } else {
      api.reload('57561894', component.options)
    }
    module.hot.accept("./cooperationBranchList.vue?vue&type=template&id=57561894&", function () {
      api.rerender('57561894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/cooperationBranchList.vue"
export default component.exports